/**
 * localStorage keys the offline layer owns.
 *
 * Deliberately a leaf module with no imports: the storage layer
 * (`rxDbInstance.ts`) and the React hooks (`useOfflineOptIn.ts`) both need
 * these literals, and importing either from the other drags its dependencies
 * along — RxDB and every collection creator in one direction,
 * `@airship-platform/airship-patterns` in the other.
 */

/** Survives every storage sweep, so the offline opt-in outlives a rebuild.
 * `SignOutPage.tsx` (a different app, deliberately not importing this one)
 * hardcodes the same literal. */
export const OPTED_IN_KEY = 'offline-data-opted-in';

/** Sorted `name:version` pairs for every registered collection. A mismatch is
 * what triggers the rebuild in `wipeIfSchemaChanged()`. */
export const SCHEMA_FINGERPRINT_KEY = 'airship:rxdb-schema-fingerprint';
